export default __webpack_public_path__ + "static/media/404_4.5eabe18a.jpg";